/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Address Book functionality

define('modules/User/AddressBook.Forms',[], function () {
    'use strict';

    var forms = {
        ShippingAddress: {
            Fields: [
                {
                    "Name": 'First Name',
                    "Field": '#shipping-first-name',
                    "Param": 'firstName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Last Name',
                    "Field": '#shipping-last-name',
                    "Param": 'lastName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Company',
                    "Field": '#shipping-company',
                    "Param": 'company',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'Address 1',
                    "Field": '#shipping-address1',
                    "Param": 'address1',
                    "Type": 'Text'
                },
                {
                    "Name": 'Address 2',
                    "Field": '#shipping-address2',
                    "Param": 'address2',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'City',
                    "Field": '#shipping-city',
                    "Param": 'city',
                    "Type": 'Text'
                },
                {
                    "Name": 'State',
                    "Field": '#shipping-state',
                    "Param": 'state',
                    "Type": 'Select',
                    "ShippingCalcReq": true
                },
                {
                    "Name": 'Region',
                    "Field": '#shipping-region',
                    "Param": 'region',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'Country',
                    "Field": '#shipping-country',
                    "Param": 'country',
                    "Type": 'Select',
                    "ShippingCalcReq": true
                },
                {
                    "Name": 'Zip/Postal Code',
                    "Field": '#shipping-zip',
                    "Param": 'zip',
                    "Type": 'Text',
                    "ShippingCalcReq": true,
                    'Optional': true,
                    "Validators": [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#shipping-country',
                                'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                                'ConditionalValue': 'true',
                                'ConditionalFieldType': 'Select'
                            },
                            {
                                "Type": 'Zip',
                                "ReferencedField": '#shipping-country',
                                'ReferencedFieldAttr': 'data-isPostalCodeRequired',
                                'ReferencedValue': 'true',
                                'ReferencedFieldType': 'Select'
                            }
                    ]
                },
                {
                    "Name": 'Phone',
                    "Field": '#shipping-phone',
                    "Param": 'phone',
                    "Type": 'Text'
                },
                {
                    "Name": 'Is Default',
                    "Field": '#shipping-hdAddressIsDefault',
                    "Param": 'isDefault',
                    "Type": 'Hidden'
                }
                // Customization :  to remove the ability for a user to mark an address an an org. address.
                //,
                //{
                //    "Name": 'Is Organization Address',
                //    "Field": '#shipping-is-organization-address',
                //    "Param": 'isOrganizationAddress',
                //    "Type": 'Checkbox',
                //    "Optional": true
                //}
                //End Customization
            ],
            Validate: true
        }
    };

    return forms;
});

